import { NavbarMenu } from '@root/core/interfaces';

export const ADMIN_SELLER_MENU: NavbarMenu[] = [
  {
    id: 1,
    name: '대시보드',
    url: '/admin/seller'
  },
  {
    id: 2,
    name: '견적 관리',
    url: '/admin/seller/quote'
  },
  {
    id: 3,
    label: '입고 관리',
    children: [
      { id: 1, name: '입고 조회', url: '/admin/seller/import' },
      { id: 2, name: '입고 신청', url: '/admin/seller/import/stock' }
    ]
  },
  {
    id: 4,
    name: '상품 관리',
    url: '/admin/seller/product'
  },
  {
    id: 5,
    name: '재고 관리',
    url: '/admin/seller/stock'
  },
  {
    id: 6,
    label: '배송 관리',
    url: '/admin/seller/shipping',
    children: [
      { id: 1, name: '배송 조회', url: '/admin/seller/shipping' },
      {
        id: 2,
        name: '배송 등록',
        url: '/admin/seller/shipping-create',
        hiddenChildren: [
          {
            url: '/admin/seller/shipping-create/csv'
          }
        ]
      },
      {
        id: 3,
        name: '반환 조회',
        url: '/admin/seller/shipping/return-tracking',
        hiddenChildren: [
          {
            url: /^\/admin\/seller\/shipping\/return-tracking\/\d+$/
          }
        ]
      },
      {
        id: 4,
        name: '반품 조회',
        url: '/admin/seller/shipping/return-request',
        hiddenChildren: [
          {
            url: /^\/admin\/seller\/shipping\/return-request\/\d+$/
          }
        ]
      },
      {
        id: 5,
        name: '폐기 조회',
        url: '/admin/seller/shipping/return-disposal',
        hiddenChildren: [
          {
            url: /^\/admin\/seller\/shipping\/return-disposal\/\d+$/
          }
        ]
      },
      {
        id: 6,
        name: '반품 요청',
        url: '/admin/seller/shipping/create-return'
      }
    ]
  },
  {
    id: 7,
    label: '반환/폐기 관리',
    children: [
      { id: 1, name: '반환 조회', url: '/admin/seller/return' },
      { id: 2, name: '폐기 조회', url: '/admin/seller/return-disposal' },
      { id: 3, name: '반환/폐기 요청', url: '/admin/seller/request' }
    ]
  },
  {
    id: 8,
    name: '정산 관리',
    url: '/admin/seller/settlement'
  },
  {
    id: 9,
    label: '국제운송 문의',
    children: [
      { id: 1, name: '포워딩 업체 조회', url: '/admin/seller/forwarding' },
      { id: 2, name: '메세지 목록', url: '/admin/seller/message' }
    ]
  }
];
